// Homepage for NPC Buyer’s Agency Website with Updated Section Layouts
import React from "react";
import HeroResultBanner from "../components/HeroResultBanner";
import CustomerReviews from "../components/CustomerReviews";
import WhoWeHelpSection from "../components/WhoWeHelpSection";
import WhyUsSection from "../components/WhyUsSection";
import ProcessFlowSection from "../components/ProcessFlowSection";
import WhoWeAreSection from "../components/WhoWeAreSection";

import YouTubeVideoCarousel from "../components/YouTubeVideoCarousel";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";



const HomePage = () => {

    const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100); // Delay ensures sections are rendered first
      }
    }
  }, [location]);


    const videoLinks = [
        "https://www.youtube.com/embed/CMDmMrZVNys",
        "https://www.youtube.com/embed/KNQcbmnJRr0",
        "https://www.youtube.com/embed/s3Lb6J7XXso",
        "https://www.youtube.com/embed/KNC9r3nHZ8g",
        "https://www.youtube.com/embed/GIMkDAohpeE",
        "https://www.youtube.com/embed/s3Lb6J7XXso",
        "https://www.youtube.com/embed/6mqnal_1LlE"
    ];


    return (


        <div className="font-sans">
            <div id="hero" className="bg-white">
                <HeroResultBanner />
            </div>

            <div id="who" className="bg-[#f9f9f9]">
                <WhoWeAreSection />
            </div>

            <div id="process" className="bg-white">
                <ProcessFlowSection />
            </div>

            <div id="reviews" className="bg-[#f9f9f9]">
                <CustomerReviews />
            </div>

            <div id="help" className="bg-white">
                <WhoWeHelpSection />
            </div>

            <div id="why" className="bg-[#f9f9f9]">
                <WhyUsSection
                />

            </div>
            <YouTubeVideoCarousel videos={videoLinks} />;
        
        </div>


    );
};

export default HomePage;
